import styled from '@emotion/styled/macro';
import { PageSectionWrapper } from 'styles';

const Section = styled(PageSectionWrapper)`
  background-color: ${props => props.theme.colors.brown[100]};
  padding: 0;
`;

export default Section;
